import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  areas: [],
  allAreas: []
};

export const AreaSlice = createSlice({
  name: "area",
  initialState,
  reducers: {
    getAreasAction: (state, action) => {
      state.allAreas = action.payload;
    },
    getAreaAction: (state, action) => {
      state.areas = action.payload;
    },
  },
});

export default AreaSlice.reducer;

export const { getAreasAction, getAreaAction } = AreaSlice.actions;
